
export const services = [
    {
        title: "Technology Enthusiast",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Software Engineer",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Computer Networking",
        icon: 'https://csgeeek.github.io/web.png',
    },
];

export const name = 'ASHISH ';

export const experiences = [
    {
        'company': '',
        'role': 'Freelancer',
        'duration': 'April 2023 - Present',
        'logo': 'https://imgs.search.brave.com/af7mGpLxzaY3ujJnyDgNn7XQTxXWv1JPN6mDLGAfGnc/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly93d3cu/aW1hZ2V0b3RleHQu/aW8vd2ViX2Fzc2V0/cy9mcm9udGVuZC9p/bWcvcGxhbi1zZWN0/aW9uMS1pbWcucG5n',
        'points': [
            'Involved in dynamic contributions to full stack web  development projects, actively influencing and improving project outcomes.',
            'Developed multiple shared components to simplify tasks for fellow developers, boosting efficiency and skills.',
            'Enhanced product performance through significant contributions to  website, optimizing essential components for improved efficiency 📈.',
           
        ],
        'url': 'https://github.com/Ashish-mishra7011',
    },
    {
        'company': 'Tech Mahindra',
        'role': 'Web Developer',
        'duration': 'Jan 2022 - March 2022',
        'logo': 'https://imgs.search.brave.com/oJED3DorTGBIc3UU9hccUGNHLmbn2I18oQgdOmAuSJg/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9pbWFn/ZS5waXRjaGJvb2su/Y29tL0UwakFIc2xO/NnJWaWlUSVVuNFAz/aEhrbjdpODE2NzE2/MDY5MTg5MjBfMjAw/eDIwMA.jpeg',
        'points': [
            'Gained experience with Front End development, contributing to the development and design responsively .',
            'Worked on the front end applications ,learned  animation and effective designing  and submitted the final year project .',
            'Got the clear understanding on the git version control and managed projects through it.'
        ],
        'url': 'https://www.techmahindra.com/',
    },
]



export const EMAIL_JS_SERVICE_ID = 'service_rjh64xe';
export const EMAIL_JS_TEMPLATE_ID = 'template_zeyubbs';
export const EMAIL_JS_PUBLIC_KEY = 'kBxlMug-v69DJjs8-';